var $class="se2--header-se--user-menu-for-apc",$name="HeaderSE/userMenuForAPC",$path="app/components/HeaderSE/partials/userMenuForAPC/config.js",$this={$class,$name,$path,};const popupWidth = 230;
export default popupWidth;
